import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import useHttpHook from "../../Hooks/HttpHook";
import { CancleTicketRequest } from "../../utils/ApiConstant";
import { dateFormatter, getAttendeePhotoUrl } from "../../utils/Helper";
import { DEFAULT_PROFILE_IMAGE } from "../../utils/brandAssets";
import { OrderLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const UserDetailsSection = ({ details, isLoading, isError, getDetials }) => {
  const [loading, sendRequest, error] = useHttpHook();
  const [refundDate, setRefundDate] = useState("");
  const [eventStartDate, setEventStartDate] = useState("");
  const { orderId } = useParams();
  const [isCancleModel, setIsCancleModel] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState({
    ticketId: "",
    attendeeId: "",
  });
  const [successModel, setSuccessModel] = useState(false);

  useEffect(() => {
    setRefundDate(
      moment(details?.eventId?.eventTiming?.startDate).subtract(
        +details.eventId?.settings?.settings?.refundSettings,
        "days"
      )
    );
    setEventStartDate(dateFormatter(details?.eventId?.eventTiming?.startDate));
  }, [details]);

  const cancelTicket = async () => {
    try {
      const res = await sendRequest(
        `${CancleTicketRequest}/${selectedTicket.ticketId}/${selectedTicket.attendeeId}`,
        {
          method: "put",
        }
      );
      setIsCancleModel(false);

      if (res.status === 1) {
        setSuccessModel(true);
      }
    } catch (err) {
      toast?.error(err?.message);
      console.log(err);
    }
  };

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const attendees = [];
  details?.tickets?.forEach((ticket) => {
    ticket.attendees?.forEach((attendee) => {
      attendees.push({ ticket, attendee });
    });
  });

  const renderCancelCell = (ticket, attendee) => {
    if (!["card", "emi"].includes(details?.paymentType)) {
      return "NA";
    }

    if (attendee.status !== "active") {
      if (
        attendee.status === "check-in" &&
        attendee.bandId &&
        attendee.cancelRequestStatus === "pending"
      ) {
        return <span className="text-danger">Request Expired</span>;
      }
      return <span className="text-danger">Not Able</span>;
    }

    if (
      ticket.cancelRequestUsers?.includes(attendee._id) &&
      attendee.cancelRequestStatus === "pending"
    ) {
      return <span className="text-success">Requested</span>;
    }
    if (attendee.cancelRequestStatus === "approved") {
      return <span className="text-success">Approved</span>;
    }
    if (attendee.cancelRequestStatus === "rejected") {
      return <span className="text-danger">Rejected</span>;
    }
    if (attendee.cancelRequestStatus === "refunded") {
      return <span className="text-danger">Refunded</span>;
    }
    if (
      moment().isBefore(refundDate) &&
      !details?.eventId?.isCancelled &&
      moment().isBefore(eventStartDate) &&
      (details?.paymentType === "card" ||
        (details?.paymentType === "emi" &&
          details?.emiInstallment === details?.emiInfo?.paid)) &&
      details?.event?.refundSettings !== ""
    ) {
      return (
        <button
          type="button"
          className="event-order-detail-cancel-btn"
          onClick={() => {
            setSelectedTicket({
              ticketId: ticket.id,
              attendeeId: attendee._id,
            });
            setIsCancleModel(true);
          }}
        >
          Cancel
        </button>
      );
    }

    return "NA";
  };

  return (
    <MainComponentWrapper
      errorInfo={isError || error}
      Loading={isLoading || loading}
    >
      <section
        className="event-order-detail-users"
        aria-label="User information details"
      >
        <h3 className="event-order-detail-section-title">
          {OrderLanguage.OrderDetails.UserInformationList.heading}
        </h3>
        <div className="event-order-detail-users-table-wrap">
          <table className="event-order-detail-users-table">
            <thead>
              <tr>
                <th scope="col">Profile</th>
                <th scope="col">
                  {
                    OrderLanguage.OrderDetails.UserInformationList.tableCoulmns
                      .name
                  }
                </th>
                <th scope="col">
                  {
                    OrderLanguage.OrderDetails.UserInformationList.tableCoulmns
                      .date
                  }
                </th>
                <th scope="col">
                  {
                    OrderLanguage.OrderDetails.UserInformationList.tableCoulmns
                      .phone
                  }
                </th>
                <th scope="col">
                  {
                    OrderLanguage.OrderDetails.UserInformationList.tableCoulmns
                      .ticketType
                  }
                </th>
                <th scope="col">
                  {
                    OrderLanguage.OrderDetails.UserInformationList.tableCoulmns
                      .email
                  }
                </th>
                <th scope="col">
                  {
                    OrderLanguage.OrderDetails.UserInformationList.tableCoulmns
                      .action
                  }
                </th>
                <th scope="col">
                  {
                    OrderLanguage.OrderDetails.UserInformationList.tableCoulmns
                      .cancelRequest
                  }
                </th>
              </tr>
            </thead>
            <tbody>
              {attendees.length ? (
                attendees.map(({ ticket, attendee }, index) => (
                  <tr
                    key={`${ticket.id}-${attendee._id}-${index}`}
                    className="event-order-detail-attendee-row"
                  >
                    <td className="event-order-detail-cell-profile">
                      {attendee.photo ? (
                        <img
                          className="event-order-detail-profile"
                          src={getAttendeePhotoUrl(attendee.photo)}
                          alt={attendee.name || ""}
                          onError={(event) => {
                            event.currentTarget.onerror = null;
                            event.currentTarget.src =
                              DEFAULT_PROFILE_IMAGE;
                          }}
                        />
                      ) : (
                        <span
                          className="event-order-detail-profile d-inline-grid place-items-center"
                          style={{
                            background: "rgba(255,255,255,.06)",
                            color: "rgba(234,240,255,.5)",
                          }}
                        >
                          <i className="fa fa-user" aria-hidden="true"></i>
                        </span>
                      )}
                    </td>
                    <td>{attendee.name}</td>
                    <td>{dateFormatter(attendee.dob)}</td>
                    <td>{attendee.mobile}</td>
                    <td>{ticket.name}</td>
                    <td>{attendee.email}</td>
                    <td className="event-order-detail-cell-action">
                      <Link
                        to={`/myOrder/ticket/${ticket.id}/${attendee._id}/${orderId}?redirectUrl=${window.location.pathname}`}
                        className="event-orders-action-btn"
                        aria-label={`View ticket details for ${attendee.name}`}
                      >
                        Details
                      </Link>
                    </td>
                    <td className="event-order-detail-cell-cancel">
                      {renderCancelCell(ticket, attendee)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="event-order-detail-empty">
                    No attendee information available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {isCancleModel && (
          <ModalWrapper
            title={OrderLanguage.OrderDetails.cancelModel.heading}
            clickHandler={cancelTicket}
            CloseModalHandler={() => setIsCancleModel(false)}
          >
            <span>{OrderLanguage.OrderDetails.cancelModel.body}</span>
          </ModalWrapper>
        )}
        {successModel && (
          <ModalWrapper
            title={OrderLanguage.CancelRequests.model.heading}
            CloseModalHandler={() => {
              setSuccessModel(false);
              getDetials();
            }}
            clickHandler={() => {
              setSuccessModel(false);
              getDetials();
            }}
          >
            <p>{OrderLanguage.CancelRequests.model.body}</p>
          </ModalWrapper>
        )}
      </section>
    </MainComponentWrapper>
  );
};

export default UserDetailsSection;
